import { AbstractControl, ValidationErrors } from '@angular/forms';
import { BaseValidationError } from '@shared/validators/validation-error/base-error';
import { BaseValidator } from '@shared/validators/base-validator';
import { TranslationService } from '@core/translation/translation.service';
import { ElectricMeter } from '@shared/models/electric-meter';

export class IsElectricMeterValidator extends BaseValidator {

    public validationError: BaseValidationError;

    constructor(message?: string) {
        super();

        this.validationError = new BaseValidationError(
            'electricMeterExists',
            message || TranslationService.translate('common.validation.pickElectricMeterFromList')
        );
    }

    public validate({value}: AbstractControl): ValidationErrors {
        return !value || (value instanceof ElectricMeter && value.id != null) ?
            this.IS_VALID :
            this.IS_INVALID;
    }
}
